import API_CLIENT from "../../utils/Api";
import { buildPayload } from "../../utils/helper";

export async function CreateBundle(payload) {
  const sanitizedPayload = buildPayload(payload);
  return await API_CLIENT.post("/bundles", sanitizedPayload);
}

export async function GetBundles(page) {
  return await API_CLIENT.get(`/bundles?page=${page}`);
}

export async function GeneratePresignedUrl({ filename, mimeType, fileSize }) {
  return await API_CLIENT.post("/bundles/generate-upload-url", {
    filename,
    mimeType,
    fileSize,
  });
}

export async function GetBundleOverview() {
  return await API_CLIENT.get("/bundles/overview");
}

export async function DeleteBundle(id) {
  return await API_CLIENT.delete(`/bundles/${id}`);
}

export async function GetSingleBundle(id) {
  return await API_CLIENT.get(`/bundles/${id}`);
}

export async function UpdateSingleBundle({ payload, id }) {
  return await API_CLIENT.put(`/bundles/${id}`, payload);
}

export async function GetBundleInventoryOverview() {
  return await API_CLIENT.get(`/bundles/inventory-overview`);
}

export async function GenerateCoverImage(payload) {
  return await API_CLIENT.post(`/bundles/generate-images`, payload);
}
